import type { DeskType } from '@cocoonspace/sdk-js/types/deskType'
import { Building, X } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import { Card } from '~/components/ui/card'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '~/components/ui/select'

export const DESK_TYPES = [
	'cocoon',
	'coworking',
	'cafe',
	'hotel',
] satisfies DeskType[]

export const DeskTypeFilter = ({
	value,
	onChange,
}: {
	value?: DeskType
	onChange: (value?: DeskType) => void
}) => {
	const { t } = useTranslation()

	return (
		<Select
			key={new Date().getTime()}
			value={value || undefined}
			onValueChange={(value) => onChange(value as DeskType | undefined)}
		>
			<Card className='flex h-[32px] flex-row items-center rounded text-sm'>
				<SelectTrigger className='border-none px-2 text-sm'>
					<Building
						size={14}
						className='text-primary'
					/>

					<SelectValue placeholder={t('search:deskTypeFilter.title')} />
				</SelectTrigger>

				{!!value && (
					<button
						type='button'
						className='absolute right-0 bg-white pr-2'
						onClick={(e) => {
							e.preventDefault()
							e.stopPropagation()
							onChange(undefined)
						}}
					>
						<X
							className='text-primary'
							size={16}
						/>
					</button>
				)}
			</Card>

			<SelectContent>
				{DESK_TYPES.map((type) => (
					<SelectItem
						key={type}
						value={type}
					>
						{t(`search:deskTypeFilter.${type}`)}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	)
}
